import React, { useCallback, useState, useMemo } from 'react';
import UFOCustomData from '@atlaskit/react-ufo/custom-data';

// UFO currently has a limitation where certain type of hover events will skew the performance measures so we need to
// filter our those events from the perf portal via a custom cohort which is based on the `hasHoverEvent` attribute.
// See HL-1951 for more details.
//
// When there are multiple UFO custom data components referencing the same data attribute, UFO respects the one which is
// the most nested in the React component tree, so we place one with `hasHoverEvent === false` at the top level and
// conditionally render the UFO custom data component with `hasHoverEvent === true` in the nested component.

export const UFOCustomHoverData = ({ hasHoverEvent }: { hasHoverEvent: boolean }) => {
	const data = useMemo(
		() => ({
			hasHoverEvent,
		}),
		[hasHoverEvent],
	);

	return <UFOCustomData data={data} />;
};

export const useUFOCustomHoverData = () => {
	const [renderCustomData, setRenderCustomData] = useState(false);

	const addUFOCustomHoverData = useCallback(() => {
		if (!renderCustomData) {
			setRenderCustomData(true);
		}
	}, [renderCustomData]);

	const UFOConditionalCustomHoverData = () =>
		renderCustomData ? <UFOCustomHoverData hasHoverEvent /> : null;

	return {
		addUFOCustomHoverData,
		UFOConditionalCustomHoverData,
	};
};
